import "./AllNumberGen.scss";
import newRequest from "../../../utils/newRequest.js";
import DeleteIcon from "@mui/icons-material/Delete";
import Forward5Icon from '@mui/icons-material/Forward5';
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Select as MuiSelect,
  MenuItem,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@mui/material";
import { showToast } from "../../../toastService.js";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GridLoader } from "react-spinners";
import { SlArrowDown } from "react-icons/sl";
import { formatStringToNumberV2, logData } from "../../../utils/genericFunctions.js";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { muiSelectStyles_dark, muiSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";

const AllNumberGen = () => {
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [commissionRates, setCommissionRates] = useState([]);

  const [searchTermNumgen, setSearchTermMortality] = useState("");
  const [numgenPage, setNumgenPage] = useState(0);
  const [numberGenerations, setNumberGenerations] = useState([]);

  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
  });

 
  const fetchNumberGenerations = async () => {
    try {
      const res = await newRequest.post("/numGen/findAll", { result_limit: 100 });
      setNumberGenerations(res.data);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  useEffect(() => {
    fetchNumberGenerations();
  }, []);

  const handleMortalityChangePage = (event, newPage) => {
    setNumgenPage(newPage);
  };

  const handleMortalityChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setNumgenPage(0);
  };

  const handleClearSearchMortality = () => {
    setSearchTermMortality("");
  };

  const filteredNumberGenData = numberGenerations.filter(
    (item) =>
      item.ng_name?.toLowerCase().includes(searchTermNumgen?.toLowerCase())
  );

  const slicedNumberGenData = filteredNumberGenData.slice(
    numgenPage * rowsPerPage,
    numgenPage * rowsPerPage + rowsPerPage
  );

  // commission rates table
  const [searchTermRates, setSearchTermRates] = useState("");
  const [savingTitle, setSavingTitle] = useState("SAVE");
  const [ratesPage, setRatesPage] = useState(0);
  const [rowsPerPageRates, setRowsPerPageRates] = useState(10);
  const [ngenParameters, setNgenParameters] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [selectedParameter, setSelectedParameter] = useState(null);
  const [selectedNgen, setSelectedNgen] = useState(null);

  const handleAccodionChange = (panel, ngen) => (event, isExpanded) => {
    try {
      setExpanded(isExpanded ? panel : false);
      setSelectedNgen(isExpanded ? ngen : null);
      setNgenParameters(ngen?.ng_params_xx);
    } catch (error) {
      console.log(error)
    }
  };

  const handleRatesChangePage = (event, newPage) => {
    setRatesPage(newPage);
  };

  const handleRatesChangeRowsPerPage = (event) => {
    setRowsPerPageRates(parseInt(event.target.value, 8));
    setRatesPage(0);
  };

  const handleClearSearchRates = () => {
    setSearchTermRates("");
  };

  // const filteredParametersData = ngenParameters.filter(
  //   (item) =>
  //     item.male?.toLowerCase().includes(searchTermRates?.toLowerCase())
  // );
  const filteredParametersData = ngenParameters;

  const slicedParametersData = filteredParametersData.slice(
    ratesPage * rowsPerPage,
    ratesPage * rowsPerPage + rowsPerPage
  );


  const formatNumber = (value, decimals = 2) => {
    try {
      if (isNaN(formatStringToNumberV2(value))) return value;
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimals
      }).format(value);
    } catch (error) {
      console.log(error)
    }
  };

  const handleNumGensChange = (e, rowId) => {
    try {
      const { name, value } = e.target;
      const updatedData = [...ngenParameters];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);
      if (rowIndex === -1) {
        throw new Error('Row not found');
      }
      updatedData[rowIndex][name] = value;
      // updatedData[rowIndex]["changed_xx"] = "Y";
      setNgenParameters(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleNumGensBlur = async (e, rowId) => {
    try {
      const { name, value } = e.target;
      const updatedData = [...ngenParameters];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);

      if (rowIndex === -1) {
        throw new Error('Row not found');
      }
      updatedData[rowIndex][name] = value;
      // console.log(`updatedData[rowIndex]  ${JSON.stringify(updatedData[rowIndex], null, 2)}`);

      const updatePayload = {
        ng_code: selectedNgen?.ng_code,
        ...updatedData[rowIndex],
      };
      console.log(`updatePayload  ${JSON.stringify(updatePayload, null, 2)}`);
      const res = await newRequest.post("/numGen/updateParameter", updatePayload);

    } catch (error) {
      console.log(error);
    }
  };

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteParameter") {
        const res = await newRequest.post("/numGen/removeParameter", {
          numgen_docid: selectedNgen._id,
          param_order: objectToAction.object_id
        });
        fetchNumberGenerations();
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  const handleCloseNotifyDialog = () => {
    setIsNotifyDialogOpen(false);
  };
  
  return (
    <motion.div
      className="number-generation"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {slicedNumberGenData?.length > 0 &&
        <div className="number-gen-table-content">
          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
            className="table-container">
            <Table sx={{ width: "max-content", border: 'none' }}>
              <TableBody className="tablebody-accordion">
                {slicedNumberGenData?.map((ngen, index) => (
                  <TableRow
                    key={ngen._id}
                    className="tablerow-accordion">
                    <TableCell className="table-cell-accordion"
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                      <Accordion className="accordion" expanded={expanded === ngen._id} onChange={handleAccodionChange(ngen._id, ngen)}>
                        <AccordionSummary
                          className="accordion-summary"
                          expandIcon={<SlArrowDown className="content-accordion-expand-icon" style={{ color: "#f44336", fontWeight: "bold" }} />}
                          id={`panel-${ngen._id}-header`}
                        >
                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", marginRight: "50px" }}>
                            <Typography>
                              <h1 className="sub-title">{numgenPage * rowsPerPage + index + 1}. {ngen.ng_name}</h1>
                            </Typography>
                            <Typography>
                              <div className="ngen-details">
                                <h1 className="account-no">{`MODULE: ${ngen.ng_module}`}</h1>
                                <h1 className="account-no">{`SEPARATOR: ${ngen.ng_separator}`}</h1>
                                <h1 className="account-no">{`CODE: ${ngen.ng_code}`}</h1>
                              </div>
                            </Typography>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details">
                          <div className="search">
                            <div className="navbar">
                              {/* <div className="navbar-left">
                                <div className="search-input-wrapper">
                                  <SearchIcon className="search-input-icon" />
                                  <input
                                    className="search-input"
                                    type="text"
                                    placeholder="Search..."
                                    value={searchTermRates}
                                    onChange={(e) => setSearchTermRates(e.target.value)}
                                  />
                                  {searchTermRates.length > 0 && (
                                    <CloseIcon
                                      onClick={handleClearSearchRates}
                                      className="search-input-icon"
                                    />
                                  )}
                                </div>
                              </div> */}
                              <div className="navbar-right">
                                {/* <CustomLoadingButton startIcon={<FaSave />} onClick={saveRecord}>
                                  {savingTitle}
                                </CustomLoadingButton> */}
                              </div>
                            </div>
                          </div>
                          <div className="table-content">
                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                              <Table sx={{ width: "max-content", border: 'none' }}>
                                <TableHead className="tablehead">
                                  <TableRow className="tablerow">
                                    <TableCell className="table-cell" style={{ display: "flex", maxWidth: "50px", fontWeight: "bold", alignItems: "center", justifyContent: "center" }}>
                                      ORDER
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ display: "flex", maxWidth: "200px" }}>
                                      TYPE
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ display: "flex", width: "auto" }}>
                                      VALUE
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ display: "flex", maxWidth: "100px" }}>
                                      REORDER
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ display: "flex", maxWidth: "100px" }}>
                                      ACTION
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody className="tablebody">
                                  {ngenParameters?.map((row, index) => (
                                    <TableRow
                                      key={row._id}
                                      className={`${selectedParameter?._id === row._id ? "tablerow current" : "tablerow"}`}
                                      onClick={() => {
                                        try {
                                          setSelectedParameter(row)
                                        } catch (error) {
                                          console.log(error)
                                        }
                                      }}
                                    >
                                      <TableCell className="table-cell" style={{ display: "flex", maxWidth: "50px", fontWeight: "bold", alignItems: "center", justifyContent: "center" }}>
                                        {row.param_order}
                                      </TableCell>
                                      <TableCell className="table-cell" style={{ display: "flex", maxWidth: "200px" }}>
                                        <span className="param_type">{row.param_type}</span>
                                      </TableCell>
                                      <TableCell className="table-cell" style={{ display: "flex", width: "auto" }}>
                                        {row.param_type === "Variable" && <span className="param_type"> {row.param_value_xx}</span>}
                                        {row.param_type === "Fixed Value" &&
                                          <div className="input-item-with-label">
                                            <input
                                              id="param_value"
                                              name="param_value"
                                              value={row.param_value}
                                              onChange={(e) => handleNumGensChange(e, row._id)}
                                              onBlur={(e) => handleNumGensBlur(e, row._id)}
                                              style={{ width: "100px" }}
                                              className="form-input-item table "
                                            />
                                          </div>}
                                        {row.param_type === "Serial No" &&
                                          <div className="serial-no-details">

                                            <div className="input-item-with-label">
                                              <label htmlFor="param_current_no">Current NO</label>
                                              <input
                                                id="param_current_no"
                                                name="param_current_no"
                                                value={row.param_current_no}
                                                onChange={(e) => handleNumGensChange(e, row._id)}
                                                onBlur={(e) => handleNumGensBlur(e, row._id)}
                                                style={{ width: "120px", textAlign: "right" }}
                                                className="form-input-item table "
                                              />
                                              <label htmlFor="param_length">Length</label>
                                              <div className="input-item-with-label">
                                                <input
                                                  id="param_length"
                                                  name="param_length"
                                                  value={row.param_length}
                                                  onChange={(e) => handleNumGensChange(e, row._id)}
                                                  onBlur={(e) => handleNumGensBlur(e, row._id)}
                                                  style={{ width: "50px", textAlign: "right" }}
                                                  className="form-input-item table "
                                                />
                                              </div>


                                              <label htmlFor="param_pad_char">Pad Character</label>
                                              <input
                                                id="param_pad_char"
                                                name="param_pad_char"
                                                value={row.param_pad_char}
                                                onChange={(e) => handleNumGensChange(e, row._id)}
                                                onBlur={(e) => handleNumGensBlur(e, row._id)}
                                                style={{ width: "50px" }}
                                                className="form-input-item table "
                                              />
                                              <label htmlFor="param_prefix">PREFIX</label>
                                              <input
                                                id="param_prefix"
                                                name="param_prefix"
                                                value={row.param_prefix}
                                                onChange={(e) => handleNumGensChange(e, row._id)}
                                                onBlur={(e) => handleNumGensBlur(e, row._id)}
                                                style={{ width: "50px" }}
                                                className="form-input-item table "
                                              />
                                              <label htmlFor="param_suffix">SUFFIX</label>
                                              <input
                                                id="param_suffix"
                                                name="param_suffix"
                                                value={row.param_suffix}
                                                onChange={(e) => handleNumGensChange(e, row._id)}
                                                onBlur={(e) => handleNumGensBlur(e, row._id)}
                                                style={{ width: "50px" }}
                                                className="form-input-item table "
                                              />
                                            </div>
                                          </div>}
                                      </TableCell>
                                      <TableCell className="table-cell" style={{ alignItems: "center", maxWidth: "100px", flexDirection: "row", gap: "5px" }}>
                                        <MuiSelect
                                          id="reorder"
                                          name="reorder"
                                          variant="outlined"
                                          size="small"
                                          style={{
                                            width: "100%"
                                          }}
                                          value={row.param_order}
                                          onChange={async (e) => {
                                            try {
                                              const newOrder = e.target.value;
                                              console.log(`new value is ${newOrder}`);
                                              if (newOrder !== row.param_order) {
                                                const res = await newRequest.post("/numGen/reorderParameter", {
                                                  ng_code: selectedNgen.ng_code,
                                                  current_param_order: row.param_order,
                                                  new_param_order: newOrder
                                                });

                                                const updatedData = [...ngenParameters];
                                                const rowIndex = updatedData.findIndex(item => item._id === row._id);
                                                if (rowIndex === -1) {
                                                  console.log('Row not found');
                                                }
                                                updatedData[rowIndex]["param_order"] = newOrder;
                                                setNgenParameters(updatedData);
                                              }
                                            } catch (error) {
                                              console.log(error);
                                            }
                                          }}
                                          sx={currentTheme === "dark" ? muiSelectStyles_dark().select : muiSelectStyles_light().select}
                                          MenuProps={{
                                            PaperProps: {
                                              sx: currentTheme === "dark" ? muiSelectStyles_dark().menu.paper : muiSelectStyles_light().menu.paper
                                            }
                                          }}
                                        >
                                          {/* Populate dropdown with reorder_xx options */}
                                          {selectedNgen?.reorder_xx?.map((option) => (
                                            <MenuItem key={option.value} value={option.value} sx={{ height: '36px' }}>
                                              {option.label}
                                            </MenuItem>
                                          ))}
                                        </MuiSelect>
                                      </TableCell>
                                      <TableCell className="table-cell" style={{ alignItems: "center", maxWidth: "100px", flexDirection: "row", gap: "5px" }}>
                                        <Tooltip
                                          title={`Reorder ${row.param_value_xx}?`}
                                          placement="right"
                                        >
                                          <Forward5Icon
                                            style={{
                                              width: "30px",
                                              height: "30px",
                                              borderRadius: "5px",
                                              padding: "3px",
                                              alignSelf: "center",
                                              cursor: "pointer",
                                              color: "rgba(0, 128, 0, 1)",
                                              backgroundColor: "rgba(0, 128, 0, 0.5)",
                                            }}
                                            onClick={() => {
                                              try {

                                              } catch (error) {
                                                console.log(error);
                                              }
                                            }}
                                          />
                                        </Tooltip>
                                        <Tooltip
                                          title={`Delete ${row.param_value_xx}?`}
                                          placement="right"
                                        >
                                          <DeleteIcon
                                            size={50}
                                            style={{
                                              width: "30px",
                                              height: "30px",
                                              borderRadius: "5px",
                                              padding: "3px",
                                              alignSelf: "center",
                                              cursor: "pointer",
                                              color: "rgba(244, 67, 54)",
                                              backgroundColor: "rgba(244, 67, 54, 0.5)",
                                            }}
                                            onClick={() => {
                                              try {
                                                let action_text = `Delete ${row.param_value_xx}?`;
                                                setObjectToAction({
                                                  object_id: row.param_order,
                                                  action_text: action_text,
                                                  new_doc_status: "deleteParameter",
                                                });

                                                setConfirmDialogAction("deleteParameter");
                                                setIsConfirmDialogOpen(true);
                                              } catch (error) {
                                                console.log(error);
                                              }
                                            }}
                                          />
                                        </Tooltip>
                                      </TableCell>

                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                              {/* <TablePagination
                                rowsPerPageOptions={[10]}
                                rowsPerPage={rowsPerPageRates}
                                onRowsPerPageChange={handleRatesChangeRowsPerPage}
                                component="div"
                                count={ngenParameters.length}
                                page={ratesPage}
                                onPageChange={handleRatesChangePage}
                              /> */}
                            </TableContainer>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10]}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleMortalityChangeRowsPerPage}
              component="div"
              count={filteredNumberGenData.length}
              page={numgenPage}
              onPageChange={handleMortalityChangePage}
            />
          </TableContainer>
        </div>
      }
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={handleCloseNotifyDialog}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={handleCloseNotifyDialog}>Close</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle="Confirmation"
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {
        isProcessing && (
          <motion.div
            className="processing-dialog"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
          >
            <div className="processing-wrapper">
              <GridLoader
                color="#bd97fc"
                style={{
                  height: "50px",
                  width: "50px",
                }}
              />
            </div>
          </motion.div>
        )
      }
    </motion.div>
  );
};

export default AllNumberGen;
